import { MAX_SELECT_COUNT_CAR_CLASSES } from "@/config/constants"

export default {
  data() {
    return {
      maxSelectCountCarClass: MAX_SELECT_COUNT_CAR_CLASSES
    }
  }
}
